import React from "react";
import AuthenticityTokenField from "../../../components/forms/AuthenticityTokenField";
import { Button } from "../../../components/ui/button";
import { FieldLabel, TextInput } from "../../../components/ui/FormControls";
import type { MainAppPageProps } from "../types";
import { OrgTradeFields } from "./OrgTradeFields";

type OrganizationSettingsFormProps = Pick<
  MainAppPageProps,
  "csrfToken" | "routes" | "organization" | "tradeOptions"
>;

export const OrganizationSettingsForm: React.FC<
  OrganizationSettingsFormProps
> = ({ csrfToken, routes, organization, tradeOptions = [] }) => {
  const action = routes.organization ?? "/organization";

  return (
    <form action={action} method="post" className="space-y-4">
      <AuthenticityTokenField csrfToken={csrfToken} />
      <input type="hidden" name="_method" value="patch" />
      <div>
        <FieldLabel htmlFor="organization_name">Company name</FieldLabel>
        <TextInput
          id="organization_name"
          name="organization[name]"
          defaultValue={organization?.name ?? ""}
          required
          maxLength={100}
        />
      </div>
      <div>
        <FieldLabel htmlFor="organization_phone">Phone</FieldLabel>
        <TextInput
          id="organization_phone"
          name="organization[phone]"
          type="tel"
          defaultValue={organization?.phone ?? ""}
          maxLength={40}
        />
      </div>
      <OrgTradeFields
        tradeOptions={tradeOptions}
        tradeSlug={organization?.tradeSlug}
        tradeType={organization?.tradeType}
      />
      <Button type="submit" variant="premium">
        Save company
      </Button>
    </form>
  );
};
